import { onBeforeUnmount, watchEffect } from 'vue-demi';
import { uid } from '@formily/shared';
import { useForm } from './useForm';
export var useFormEffects = function (effects) {
    var formRef = useForm();
    var stop = watchEffect(function (onCleanup) {
        var id = uid();
        formRef.value.addEffects(id, effects);
        onCleanup(function () {
            formRef.value.removeEffects(id);
        });
    });
    onBeforeUnmount(function () { return stop(); });
};
//# sourceMappingURL=useFormEffects.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/hooks/useFormEffects.js
// module id = null
// module chunks = 